import script from "./UplineTree.vue?vue&type=script&lang=ts&setup=true"
export * from "./UplineTree.vue?vue&type=script&lang=ts&setup=true"

import "./UplineTree.vue?vue&type=style&index=0&id=ad387e08&lang=css"

const __exports__ = script;

export default __exports__